<template>
    <div>

        <el-container>
            <el-header><common-header /></el-header>
            <el-container>
                <el-aside width="auto">
                    <common-asideVue />
                </el-aside>
                <el-main class="el-main">
                    <airticketorderdetailstwo-right />
                </el-main>
            </el-container>
        </el-container>Airticketorderdetailstwo
    </div>
</template>

<script>
    import ElContainer from "element-ui/packages/container/src/main";
    import CommonAsideVue from '@/components/CommonAside.vue'
    import CommonHeader from '@/components/CommonHeader.vue'
    import AirticketorderdetailstwoRight from "../components/AirticketorderdetailstwoRight";
    export default {
        components: {
            AirticketorderdetailstwoRight,
            ElContainer,CommonHeader,CommonAsideVue},
        name: "airticketorderdetailstwo",
        data () {
            return {}
        },
        methods: {

        }
    }
</script>

<style scoped>
    .el-header{
        padding:0;
    }
</style>